var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 537,
    height: 403,
    viewBox: "0 0 537 403",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.078 293.305L121.487 300.258C125.874 302.726 130.867 303.914 135.896 303.689C140.926 303.461 145.791 301.829 149.938 298.974C152.25 297.429 154.292 295.514 155.982 293.305H109.078Z",
    fill: "#E06C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6606 240.461V284.155L66.6641 269.984C68.3883 256.923 74.9103 244.967 84.9616 236.449L92.6606 240.461Z",
    fill: "#E06C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M195.989 293.27L189.039 356.835C200.361 363.591 212.75 364.399 225.406 361.542L236.798 293.27H195.989Z",
    fill: "#E06C00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M181.232 194.95L177.434 183.504H156.142C151.488 189.134 140.577 204.053 138.599 219.336C137.957 224.15 136.459 230.996 135.336 236.077H214.384L198.552 206.716C194.772 206.939 191.024 205.906 187.891 203.778C184.759 201.649 182.417 198.546 181.232 194.95Z",
    fill: "#E06C00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M423.877 401.07H381.57V391.496H423.877V401.07Z",
    fill: "#004990"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M417.994 388.395L390.289 374.703L393.338 360.797L413.341 370.745L417.994 388.395Z",
    fill: "#004990"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M408.79 353.204L396.328 347L398.414 337.266H404.618L408.79 353.204Z",
    fill: "#004990"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M411.574 160.453L407.422 167.567L398.417 151.949L381.516 181.259H423.555L411.574 160.453Z",
    fill: "#004990"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M420.349 159.116C422.328 159.116 423.933 157.512 423.933 155.533C423.933 153.554 422.328 151.949 420.349 151.949C418.37 151.949 416.766 153.554 416.766 155.533C416.766 157.512 418.37 159.116 420.349 159.116Z",
    fill: "#004990"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M168.5 115.312L172.03 121.41C172.351 119.752 172.725 118.201 172.875 117.719C171.365 117.013 169.904 116.209 168.5 115.312Z",
    fill: "#004990"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M185.075 85.6856L179.619 87.7152C178.905 85.9344 177.79 84.342 176.36 83.062C174.931 81.7817 173.226 80.8485 171.377 80.3342C171.725 80.1144 171.999 79.7969 172.167 79.4213C172.335 79.0458 172.387 78.6289 172.319 78.2233C172.25 77.8179 172.063 77.4418 171.782 77.142C171.5 76.8425 171.136 76.6331 170.735 76.5396C167.747 75.9367 164.654 76.1281 161.763 77.0947C158.872 78.0614 156.286 79.7696 154.262 82.0486C153.998 82.3456 153.825 82.7115 153.762 83.1034C153.699 83.4952 153.749 83.8969 153.906 84.2615C154.063 84.626 154.321 84.9382 154.649 85.1617C154.978 85.3849 155.363 85.5099 155.759 85.5223C154.13 87.5271 153.1 89.9511 152.788 92.5153C152.476 95.0795 152.894 97.6797 153.994 100.017L157.108 98.8316C158.355 103.474 161.544 109.565 163.14 114.083C163.509 110.326 163.164 106.534 162.124 102.905C161.583 102.844 161.059 102.675 160.584 102.408C160.109 102.14 159.692 101.781 159.359 101.35C159.025 100.919 158.781 100.425 158.642 99.8985C158.502 99.3718 158.47 98.8223 158.546 98.2827L162.282 96.8752C162.883 97.2206 163.533 97.4731 164.21 97.624C165.055 97.8238 165.167 96.4192 165.221 95.7548L185.871 87.8897C187.684 86.972 185.978 85.0494 185.075 85.6856Z",
    fill: "#004990"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M180.047 236.077H184.379L186.893 219.016L180.047 236.077Z",
    fill: "#004990"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M247.119 397.593C239.553 390.913 227.977 382.955 217.703 379.945C208.53 382.591 198.798 382.591 189.626 379.945C187.708 385.359 186.538 391.008 186.149 396.737C186.114 397.258 186.187 397.781 186.362 398.274C186.538 398.766 186.813 399.217 187.171 399.6C187.528 399.98 187.961 400.284 188.441 400.489C188.921 400.697 189.438 400.804 189.961 400.802C207.977 400.855 223.493 401.016 245.85 401.069C246.253 401.069 246.648 400.945 246.978 400.714C247.309 400.481 247.561 400.154 247.7 399.774C247.838 399.394 247.857 398.983 247.753 398.592C247.649 398.203 247.428 397.854 247.119 397.593Z",
    fill: "#004990"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6281 223.509C57.0144 223.255 56.3295 223.238 55.7026 223.455C42.4946 228.122 23.7496 231.99 2.49923 243.138C2.02904 243.388 1.64462 243.774 1.3955 244.244C1.14637 244.714 1.04399 245.249 1.10155 245.778C1.15909 246.307 1.37396 246.808 1.71841 247.214C2.06285 247.622 2.5211 247.915 3.03408 248.058C18.8089 252.185 35.0242 254.395 51.3281 254.637C56.8905 241.48 60.9526 235.275 67.6945 231.272C65.0191 227.906 61.5643 225.24 57.6281 223.509Z",
    fill: "#004990"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M500.677 215.592C500.677 216.302 500.395 216.983 499.894 217.484C499.393 217.985 498.712 218.266 498.002 218.266C497.293 218.266 496.612 217.985 496.111 217.484C495.61 216.983 495.328 216.302 495.328 215.592C495.328 214.883 495.61 214.202 496.111 213.701C496.612 213.199 497.293 212.918 498.002 212.918C498.712 212.918 499.393 213.199 499.894 213.701C500.395 214.202 500.677 214.883 500.677 215.592Z",
    fill: "#004990"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2235 215.592C95.2235 216.302 94.9417 216.983 94.4401 217.484C93.9387 217.985 93.2586 218.266 92.5493 218.266C91.8399 218.266 91.1598 217.985 90.6581 217.484C90.1568 216.983 89.875 216.302 89.875 215.592C89.875 214.883 90.1568 214.202 90.6581 213.701C91.1598 213.199 91.8399 212.918 92.5493 212.918C93.2586 212.918 93.9387 213.199 94.4401 213.701C94.9417 214.202 95.2235 214.883 95.2235 215.592Z",
    fill: "#004990"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M284.978 293.304H233.261L117.953 236.078H169.617L284.978 293.304Z",
    fill: "#004990"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M380.072 293.304H328.408L213.047 236.078H264.764L380.072 293.304Z",
    fill: "#004990"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M475.221 293.304H423.557L308.195 236.078H359.912L475.221 293.304Z",
    fill: "#004990"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M498.055 257.419V283.089L403.336 236.078H455.053L498.055 257.419Z",
    fill: "#004990"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M189.836 293.304H138.116L92.6562 270.734V245.117L189.836 293.304Z",
    fill: "#004990"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M423.877 401.07H381.57V391.496H423.877V401.07Z",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M417.994 388.399L390.289 374.707L393.338 360.801L413.341 370.749L417.994 388.399Z",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M408.79 353.204L396.328 347L398.414 337.266H404.618L408.79 353.204Z",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M413.339 370.747L393.336 360.799L396.331 347L408.793 353.204L413.339 370.747Z",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M418.793 391.391H386.648L390.285 374.707L417.991 388.399L418.793 391.391Z",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M182.564 89.1406C183.779 89.6065 184.824 90.431 185.559 91.5044C186.295 92.5777 186.687 93.8496 186.683 95.1507C186.679 96.5041 186.255 97.8227 185.469 98.9244C184.684 100.027 183.575 100.857 182.297 101.301",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M163.152 114.086C161.545 109.531 158.367 103.476 157.156 98.8203",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M162.398 96.8639C162.897 97.1696 163.436 97.4027 164 97.5564C165.126 97.8379 165.025 96.9596 165.126 95.8477",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M193.898 137.617H230.001V159.115",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M192.031 134.785L210.858 162.434L249.528 155.748",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M464.501 236.08V108.738C464.506 97.6054 460.092 86.9267 452.227 79.0487C444.362 71.1706 433.69 66.7387 422.557 66.7266H168.233C162.721 66.724 157.263 67.8072 152.17 69.9146C147.076 72.0219 142.448 75.1122 138.55 79.0084C134.651 82.9046 131.558 87.5308 129.448 92.6226C127.337 97.7146 126.251 103.172 126.25 108.684V236.08",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M140.258 303.145C147.951 310.019 157.913 313.811 168.23 313.788H193.473",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M458.585 293.305C454.863 299.543 449.585 304.711 443.271 308.3C436.954 311.889 429.818 313.781 422.553 313.789H233.531",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M179.086 117.723H464.468",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M126.25 117.723H162.296",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M206.894 95.1519C206.893 96.4423 206.509 97.7034 205.792 98.7759C205.074 99.8482 204.054 100.684 202.861 101.177C201.669 101.67 200.357 101.798 199.091 101.545C197.826 101.293 196.664 100.67 195.752 99.7572C194.84 98.8443 194.219 97.6814 193.968 96.4155C193.717 95.1496 193.847 93.8378 194.342 92.646C194.836 91.4541 195.673 90.4354 196.746 89.7192C197.82 89.0028 199.081 88.6205 200.372 88.6211C201.229 88.6205 202.078 88.7889 202.87 89.1168C203.663 89.445 204.382 89.9261 204.988 90.5328C205.594 91.1397 206.074 91.8597 206.402 92.6525C206.728 93.4452 206.896 94.2944 206.894 95.1519Z",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M249.523 169.331V137.617H341.245V195.485H249.523V193.399",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M444.678 195.485H360.766V137.617H444.678V195.485Z",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M147.475 195.485H146.031V137.617H156.621",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M249.523 236.079V215.434H341.245V236.079",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M360.766 236.079V215.434H444.678V236.079",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M203.258 215.434H230V236.079",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M341.245 137.617L291.133 169.224",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M249.523 137.617L341.245 195.485",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M398.417 151.949L381.516 181.259H415.318L398.417 151.949Z",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M411.571 160.453L407.453 167.567L415.315 181.259H423.552L411.571 160.453Z",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M420.349 159.116C422.328 159.116 423.933 157.512 423.933 155.533C423.933 153.553 422.328 151.949 420.349 151.949C418.37 151.949 416.766 153.553 416.766 155.533C416.766 157.512 418.37 159.116 420.349 159.116Z",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M261.023 169.066C268.474 168.165 275.743 166.127 282.575 163.023C286.648 161.334 287.87 163.611 283.752 166.499C279.937 169.067 275.87 171.236 271.611 172.974",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M275.302 171.364C279.542 170.502 283.722 169.374 287.818 167.986C291.945 166.402 292.783 169.152 288.513 171.73C283.325 174.472 277.946 176.831 272.414 178.79",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M278.402 176.554C281.456 176.193 284.491 175.675 287.494 175.003C291.762 173.942 292.302 176.864 287.762 178.8C282.971 180.653 278.033 182.102 273 183.133",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M277.549 182.115C279.655 182.134 281.763 182.045 283.86 181.847C288.136 181.284 288.136 183.497 283.593 185.163C279.089 186.813 274.34 188.001 269.74 189.228C263.913 190.782 256.048 192.325 249.633 193.451",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M264.446 168.604C274.018 156.499 271.704 154.12 262.254 162.38C257.318 166.63 251.268 169.377 244.82 170.295",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M172.002 121.312L168.5 115.316C169.931 116.189 171.414 116.975 172.939 117.67",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M178.662 90.6289C184.65 100.822 184.622 120.186 175.397 118.365L172.937 117.67L171.974 121.414C171.567 123.058 171.641 124.785 172.188 126.388L160.421 124.355C161.559 120.997 162.471 117.566 163.149 114.086C163.536 110.333 163.21 106.54 162.186 102.908C159.109 102.154 158.211 99.9269 158.614 98.266",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M185.075 85.6868C184.776 85.791 179.619 87.7164 179.619 87.7164C178.905 85.9357 177.79 84.3432 176.36 83.0632C174.931 81.783 173.226 80.8498 171.377 80.3355C171.725 80.1157 171.999 79.7981 172.167 79.4226C172.335 79.0468 172.387 78.6302 172.319 78.2245C172.25 77.8192 172.063 77.4428 171.782 77.1433C171.5 76.8438 171.136 76.6343 170.735 76.5409C167.747 75.9281 164.651 76.1147 161.758 77.0819C158.866 78.0492 156.28 79.7629 154.262 82.0498C153.998 82.3468 153.825 82.7128 153.762 83.1046C153.699 83.4965 153.749 83.8982 153.906 84.2627C154.063 84.6273 154.321 84.9394 154.649 85.1627C154.978 85.3862 155.363 85.5112 155.759 85.5235C154.13 87.5284 153.1 89.9524 152.788 92.5166C152.476 95.0808 152.894 97.681 153.994 100.018L185.871 87.8769C186.018 87.8265 186.153 87.7477 186.268 87.6447C186.384 87.5416 186.477 87.4166 186.544 87.277C186.611 87.1371 186.649 86.9857 186.656 86.8311C186.664 86.6766 186.64 86.522 186.588 86.3765C186.535 86.2312 186.453 86.0975 186.348 85.9841C186.243 85.8704 186.117 85.7786 185.976 85.7144C185.835 85.6502 185.683 85.6148 185.528 85.61C185.373 85.6052 185.219 85.6314 185.075 85.6868Z",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M186.893 219.016L184.379 236.077H180.047L186.893 219.016Z",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M155.927 293.305C151.962 298.403 146.3 301.907 139.97 303.183C133.639 304.458 127.062 303.422 121.432 300.258L109.023 293.305",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6606 240.465L84.9616 236.453C75.0781 244.2 69.3552 255.677 66.6641 269.988L92.6521 284.105",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M135.656 236.077C136.833 230.621 137.86 224.845 138.598 219.336C141.199 199.98 156.088 183.504 156.088 183.504H177.428",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M195.936 293.358L189.039 356.842C199.305 363.26 211.559 364.49 225.406 361.549L236.157 298.279C236.424 296.621 236.638 294.963 236.745 293.305",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M198.609 206.82L214.387 236.023",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M245.835 401.085C223.481 400.73 207.968 400.845 189.946 400.817C189.425 400.814 188.91 400.708 188.432 400.499C187.954 400.291 187.524 399.987 187.169 399.607C186.813 399.224 186.539 398.776 186.363 398.284C186.188 397.794 186.115 397.273 186.149 396.752C186.549 391.024 187.718 385.377 189.625 379.961C198.797 382.61 208.53 382.61 217.702 379.961C227.971 382.956 239.552 390.939 247.119 397.608C247.428 397.87 247.65 398.219 247.753 398.61C247.857 399.002 247.837 399.415 247.697 399.795C247.556 400.175 247.302 400.505 246.969 400.736C246.636 400.966 246.24 401.088 245.835 401.085Z",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M189.57 380L192.937 358.98",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M219.998 362.512L217.484 380.001",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6281 223.509C57.0144 223.255 56.3295 223.238 55.7026 223.455C42.4946 228.122 23.7496 231.99 2.49923 243.138C2.02904 243.388 1.64462 243.774 1.3955 244.244C1.14637 244.714 1.04399 245.249 1.10155 245.778C1.15909 246.307 1.37396 246.808 1.71841 247.214C2.06285 247.622 2.5211 247.915 3.03408 248.058C18.8089 252.185 35.0242 254.395 51.3281 254.637C56.8905 241.48 60.9526 235.275 67.6945 231.272C65.0191 227.906 61.5643 225.24 57.6281 223.509Z",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6797 231.051L81.8532 238.967",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3203 254.637L68.0583 263.783",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6562 216.184V401.126",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M498.055 401.125V216.18",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7812 401.07H535.921",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M498.056 236.078H92.6562",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M498.056 293.305H92.6562",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0384 173.156H62.8125",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9297 185.27V160.988",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M518.109 123.713C518.23 125.104 517.937 126.499 517.264 127.724C516.595 128.948 515.573 129.945 514.334 130.59C513.095 131.235 511.694 131.498 510.306 131.346C508.918 131.194 507.606 130.633 506.536 129.736C505.467 128.838 504.687 127.643 504.299 126.303C503.907 124.962 503.921 123.536 504.344 122.204C504.763 120.873 505.568 119.696 506.658 118.822C507.747 117.947 509.07 117.416 510.461 117.294C511.384 117.211 512.316 117.31 513.202 117.588C514.086 117.866 514.908 118.316 515.621 118.912C516.33 119.509 516.915 120.24 517.343 121.064C517.771 121.888 518.03 122.788 518.109 123.713Z",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M339.858 1.87891L333.867 15.2755H344.778L338.788 28.6186",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M153.898 212.919C162.402 210.703 169.836 205.527 174.865 198.32",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M191.117 339.887C203.015 344.225 215.76 345.728 228.34 344.272",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M169.78 160.453L181.231 194.95C182.544 198.935 185.271 202.3 188.898 204.409C192.525 206.517 196.799 207.224 200.911 206.393L248.991 196.78C251.029 187.471 247.657 174.843 243.699 168.208L205.612 174.787C200.37 158.795 198.459 148.199 195.557 141.038C191.937 132.1 186.895 128.525 172.192 126.4L160.425 124.367C159.891 126.025 159.347 127.787 158.767 129.662C153.391 147.109 152.472 165.625 156.093 183.519",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M284.978 293.304H233.261L117.953 236.078H169.617L284.978 293.304Z",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M380.072 293.304H328.408L213.047 236.078H264.764L380.072 293.304Z",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M475.221 293.304H423.557L308.195 236.078H359.912L475.221 293.304Z",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M498.055 257.419V283.089L403.336 236.078H455.053L498.055 257.419Z",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M189.836 293.304H138.116L92.6562 270.734V245.117L189.836 293.304Z",
    stroke: "#004990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound1);
export default __webpack_public_path__ + "static/media/not_found_1.ae81676daa7c38b727929e9e01b2ea27.svg";
export { ForwardRef as ReactComponent };